import PaginationState from '../pagination/PaginationState'
import Page from '../pagination/Page'

import AppError from '@revas/kadra-library/src/core/app/vue/vuex/AppError'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import { AxiosInstance } from 'axios'

import { AvailabilityPeriod } from '@/models'
import { safeAxiosPost } from '../../../../utils/safe-post'
import { createUtcIsoDate, substractDays } from '@/store/helper'

export default class ListAvailabilityPeriodsPagination extends PaginationState<AvailabilityPeriod> {
  axios: AxiosInstance | null = null
  appStoreModule: AppStoreModule
  contactId: string

  constructor (axios: AxiosInstance, appStoreModule: AppStoreModule, contactId: string, pageSize: number, search: string) {
    super(pageSize, search)
    this.axios = axios
    this.appStoreModule = appStoreModule
    this.contactId = contactId
  }

  async asyncRequestPage (token: string): Promise<[Page<AvailabilityPeriod>, string]> {
    if (this.axios === null) {
      throw new Error('axios not configured')
    }

    if (this.appStoreModule === null) {
      throw new Error('appStoreModule is null')
    }

    const [res, err] = await safeAxiosPost<any>(this.axios, '/availabilities/availabilities.ListAvailabilityPeriods/', {
      contactId: this.contactId,
      pageSize: this.pageSize,
      pageToken: token,
      search: this.search
    })

    const newPage = new Page<AvailabilityPeriod>()
    if (err !== null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return [newPage, '']
    } else {
      const availabilityPeriods: AvailabilityPeriod[] = res.availabilityPeriods
      availabilityPeriods.map(ap => { ap.effectiveTo = createUtcIsoDate(substractDays(new Date(ap.effectiveTo), 1)) })
      newPage.items = availabilityPeriods
      return [newPage, res.nextPageToken]
    }
  }

  clone (): PaginationState<AvailabilityPeriod> {
    if (this.axios === null) {
      throw new Error('axios not configured')
    }

    if (this.appStoreModule === null) {
      throw new Error('appStoreModule is null')
    }

    const p = new ListAvailabilityPeriodsPagination(this.axios, this.appStoreModule, this.contactId, this.pageSize, this.search)
    p.tokens = this.tokens
    p.currentPage = this.currentPage
    return p
  }
}
